import client from './utils/Client';

const LEVELS = ['debug', 'log', 'info', 'warn', 'error'];
const FLUSH_INTERVAL_MS = 5000;
const ENDPOINT = '/api/ot';

let buffer = [];
let flushTimer = null;
let initialized = false;

const serializeArg = arg => {
    if (typeof arg === 'string') return arg;
    try {
        return JSON.stringify(arg);
    } catch (e) {
        return String(arg);
    }
};

const flush = () => {
    if (!buffer.length) return;
    const entries = buffer;
    buffer = [];
    client.post(ENDPOINT, { entries }).catch(() => {});
};

const patchConsole = () => {
    LEVELS.forEach(level => {
        const original = console[level].bind(console);
        console[level] = (...args) => {
            original(...args);
            buffer.push({
                type: 'log',
                level,
                message: args.map(serializeArg).join(' '),
                timestamp: Date.now(),
                url: window.location.href,
            });
        };
    });
};

const patchGlobalErrorHandlers = () => {
    window.addEventListener('error', event => {
        const error = event.error;
        buffer.push({
            type: 'error',
            message: error ? error.message : event.message,
            stack: error ? error.stack : undefined,
            timestamp: Date.now(),
            url: window.location.href,
        });
    });

    window.addEventListener('unhandledrejection', event => {
        const reason = event.reason;
        buffer.push({
            type: 'error',
            message: reason instanceof Error ? reason.message : String(reason),
            stack: reason instanceof Error ? reason.stack : undefined,
            timestamp: Date.now(),
            url: window.location.href,
        });
    });
};

export const initOt = () => {
    if (initialized || typeof window === 'undefined') return;
    initialized = true;

    patchConsole();
    patchGlobalErrorHandlers();

    flushTimer = setInterval(flush, FLUSH_INTERVAL_MS);
    window.addEventListener('beforeunload', flush);
};
